import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { initGA, trackPageView } from "./utils/googleAnalytics";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

if (window.location.host === process.env.REACT_APP_PRODUCTION_HOST) {
  initGA();
  trackPageView(window.location.pathname);
}

reportWebVitals();
